module.exports = __webpack_public_path__ + "static/US-50-Cent-7cc3af6874dd51681bc03aa58f54f38f.png";